import Vue from 'vue';

export const matchesQuery = (item, query) => {
   for (const [key, value] of Object.entries(query)) {
      if (item[key] !== value) {
         return false;
      }
   }
   return true;
};

export function setPromise(state, { key, promise }) {
   Vue.set(state.promises, key, promise);
}

export function commonGetters(listProp, identifier) {
   return {
      all: state => state[listProp],
      query: state => query => state[listProp].filter(item => matchesQuery(item, query)),
      // noinspection JSCheckFunctionSignatures
      find: state => query => state[listProp].find(item => matchesQuery(item, query)),
      get: (state, getters) => primary => getters.find({ [identifier]: primary }),
      loaded: state => state.loaded,
      exists: (state, getters) => primary => !!getters.get(primary),
   };
}

export function sortCompaniesInPrioritizedOrder(companies) {
   return companies.sort((a, b) => {
      const activeDiff = b.active - a.active;
      if (activeDiff !== 0) {
         return activeDiff;
      }
      const warningsDiff = a.warnings.length - b.warnings.length;
      if (warningsDiff !== 0) {
         return warningsDiff;
      }
      const priorityDiff = a.priority - b.priority;
      if (priorityDiff !== 0) {
         return priorityDiff;
      }
      const assignmentsDiff = a.assignment_counts.daily - b.assignment_counts.daily;
      if (assignmentsDiff !== 0) {
         return assignmentsDiff;
      }
      if (a.capacity && b.capacity) {
         let capacityA = a.capacity.daily;
         if (capacityA === null) {
            capacityA = 999999;
         }
         let capacityB = b.capacity.daily;
         if (capacityB === null) {
            capacityB = 999999;
         }
         const capacityDiff = capacityA - capacityB;
         if (capacityDiff !== 0) {
            return capacityDiff;
         }
      }

      return a.created_at - b.created_at;
   });
}

export class PromiseManager {
   constructor(key, state, commit) {
      this.key = key;
      this.state = state;
      this.commit = commit;
   }

   promiseExists() {
      return !!this.state.promises[this.key];
   }

   getPromise() {
      return this.state.promises[this.key];
   }

   addPromise(promise) {
      this.commit('setPromise', {
         key: this.key,
         promise,
      });
      return promise.then(() => {
         this.commit('setPromise', {
            key: this.key,
            promise: null,
         });
      });
   }

   static process(key, state, commit, callback) {
      const instance = new PromiseManager(key, state, commit);
      return instance.promiseExists() ? instance.getPromise() : instance.addPromise(callback());
   }
}
